<template>
  <div class="catalog-menu__wrap">
    <ul class="menu__list--catalog catalog-menu">
      <li
        v-for="category in props.categories"        
        class="catalog-menu__item">
        <a  
          :href="category.link"
          @mouseover="showSublist($event, category)"
          @click.prevent="showSublist($event, category)">
          <span>{{ category.name }}</span>
          <IconDef 
            v-if="category.children.length"
            name="catalog-arrow">
          </IconDef>
        </a>  
        <!-- <ul
          v-if="category.children.length" 
          class="catalog-menu__sublist">
          <li class="catalog-menu__item catalog-menu__item--child">
            <NuxtLink :to="category.link">
              <span>Смотреть все</span>
            </NuxtLink> 
          </li>
          <li
            v-for="child in category.children"
            class="catalog-menu__item catalog-menu__item--child">
            <NuxtLink :to="child.link">
              <span>{{ child.name }}</span>
              <IconDef 
                v-if="child.children.length"
                name="catalog-arrow">
              </IconDef>
            </NuxtLink> 
            <ul
              v-if="child.children.length"
              class="catalog-menu__sublist">
              <li class="catalog-menu__item catalog-menu__item--child">
                <NuxtLink :to="child.link">
                  <span>Смотреть все</span>
                </NuxtLink> 
              </li>
              <li
                v-for="subChild in child.children"
                class="catalog-menu__item catalog-menu__item--child">
                <NuxtLink :to="subChild.link">
                  <span>{{ subChild.name }}</span>
                </NuxtLink>
              </li>    
            </ul>
          </li> 
        </ul>     -->
      </li>
    </ul>

    <ul       
      @mouseleave="hideSublist"
      class="catalog-menu__sublist"
      :class="{'show' : isShowSublist}">
      <li         
        @click="hideSublist"
        class="catalog-menu__item catalog-menu__item--child catalog-menu__item--back">
        <NuxtLink :to="linkMenu">
          <IconDef name="catalog-arrow"></IconDef>
          <span>Назад</span>
        </NuxtLink>
      </li>
      <li
        v-for="child in sublist"
        class="catalog-menu__item catalog-menu__item--child">
        <NuxtLink :to="child.link" @click="$emit('closeMenu')">
          <span>{{ child.name }}</span>
          <IconDef 
            v-if="child.children.length"
            name="catalog-arrow">
          </IconDef>
        </NuxtLink> 
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import IconDef from "~/components/UI/IconDef.vue";
import type {PropType} from "vue";
import {Taxonomy} from "~/dto/Taxonomy";

const props = defineProps({
  categories: {
    type: Array as PropType<Array<Taxonomy>>,
    required: true,
  }
});

const emit = defineEmits()

const router = useRouter();

const isShowSublist = ref(false) 
const sublist = ref([])
let linkMenu = ref('')

const showSublist = (e, val) => {
  if(e.type !== 'click' && val.children.length) {
    isShowSublist.value = true
    linkMenu.value = val.link
    sublist.value = val.children
  }else if(e.type !== 'click' && !val.children.length){
    isShowSublist.value = false
    sublist.value = []
    linkMenu.value = ''
  }

  if(e.type === 'click' && val.children.length) {
    if (window.innerWidth > 1200) { 
      emit('closeMenu') 
      router.push(val.link);
    } else {
      isShowSublist.value = true
      linkMenu.value = val.link
      sublist.value = val.children
      console.log('2')
    }
  } else if (e.type === 'click' && !val.children.length) {
    emit('closeMenu') 
    router.push(val.link)
  }
}
const hideSublist = () => {
  isShowSublist.value = false
  sublist.value = []
}
</script>